"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainRoutesLegendIcon = MainRoutesLegendIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function MainRoutesLegendIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_15479_117268)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M32 11H0V21H32V11Z",
    fill: "#F4BFE6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M-16 16H48",
    stroke: "white",
    strokeDasharray: "4 4",
    strokeWidth: "2"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_15479_117268"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    height: "32",
    width: "32"
  }))));
}